import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Listings API
export const listingsApi = {
  getAll: (params) => api.get('/listings', { params }),
  getById: (id) => api.get(`/listings/${id}`),
  create: (data) => api.post('/listings', data),
  update: (id, data) => api.put(`/listings/${id}`, data),
  delete: (id) => api.delete(`/listings/${id}`),
  getHostListings: () => api.get('/host/listings'),
};

// Bookings API
export const bookingsApi = {
  getAll: (params) => api.get('/bookings', { params }),
  getById: (id) => api.get(`/bookings/${id}`),
  create: (data) => api.post('/bookings', data),
  updateStatus: (id, status) => api.patch(`/bookings/${id}/status?new_status=${status}`),
};

// Messages API
export const messagesApi = {
  getThreads: () => api.get('/messages/threads'),
  getThread: (threadId) => api.get(`/messages/thread/${threadId}`),
  send: (data) => api.post('/messages', data),
};

// Reviews API
export const reviewsApi = {
  create: (data) => api.post('/reviews', data),
  getByListing: (listingId) => api.get(`/reviews/listing/${listingId}`),
};

// Disputes API
export const disputesApi = {
  getAll: () => api.get('/disputes'),
  create: (data) => api.post('/disputes', data),
  resolve: (id, resolution) => api.patch(`/disputes/${id}/resolve?resolution=${resolution}`),
};

// Availability API
export const availabilityApi = {
  get: (listingId) => api.get(`/availability/${listingId}`),
  block: (data) => api.post('/availability/block', data),
};

// Admin API
export const adminApi = {
  getListings: (params) => api.get('/admin/listings', { params }),
  updateListingStatus: (id, status) => api.patch(`/admin/listings/${id}/status?new_status=${status}`),
  getUsers: (params) => api.get('/admin/users', { params }),
  suspendUser: (id, suspend) => api.patch(`/admin/users/${id}/suspend?suspend=${suspend}`),
  issueRefund: (bookingId, amount) => api.post(`/admin/refund/${bookingId}?amount=${amount}`),
  getMetrics: () => api.get('/admin/metrics'),
};

export default api;
